export default function () {

  const ciaState = useState<{
    cartId?: string;
    email?: string;
    userId?: string;
  }>('cia-state', () => ({}));

  function setCartId(cartId: string) {

    ciaState.value.cartId = cartId;
  
  }

  function setEmail(email: string) {

    ciaState.value.email = email;
  
  }

  function setUserId(userId: string) {

    ciaState.value.userId = userId;
  
  }

  return {
    ciaState: computed(() => ciaState.value),
    setCartId,
    setEmail,
    setUserId,
  };

}
